import { api } from './api-client';
import type {
  ListPlatformDevelopersResponse,
  PlatformDeveloper,
  CreateDeveloperRequest,
  CreateDeveloperResponse,
  CreateClusterRequest,
  CreateClusterResponse,
  UpdateClusterRequest,
} from '@residenone/shared';

export type { PlatformDeveloper };

// Migration 0002 used this record to hold properties created before companies
// existed. It is a review queue for legacy ownership, not a B2B client.
export const LEGACY_COMPANY_ID = 'de000000-0000-4000-8000-000000000001';
export const isLegacyCompany = (id: string): boolean => id === LEGACY_COMPANY_ID;

export interface PlatformSearchResults {
  developers: { id: string; name: string }[];
  clusters: { id: string; name: string; developer_id: string | null; developer_name: string | null }[];
  members: { id: string; name: string; email: string; cluster_id: string; cluster_name: string; developer_id: string | null }[];
}

export async function searchPlatform(q: string): Promise<PlatformSearchResults> {
  const { data } = await api.get<PlatformSearchResults>('/platform/search', { params: { q } });
  return data;
}

export async function listDevelopers(): Promise<PlatformDeveloper[]> {
  const { data } = await api.get<ListPlatformDevelopersResponse>('/platform/developers');
  return data.developers;
}
export async function createDeveloper(body: CreateDeveloperRequest): Promise<CreateDeveloperResponse> {
  const { data } = await api.post<CreateDeveloperResponse>('/platform/developers', body);
  return data;
}
export async function createCluster(body: CreateClusterRequest): Promise<CreateClusterResponse> {
  const { data } = await api.post<CreateClusterResponse>('/platform/clusters', body);
  return data;
}
export async function archiveDeveloper(id: string): Promise<void> {
  await api.post(`/platform/developers/${id}/archive`);
}
export async function restoreDeveloper(id: string): Promise<void> {
  await api.post(`/platform/developers/${id}/restore`);
}
export async function updateCluster(id: string, body: UpdateClusterRequest): Promise<void> {
  await api.patch(`/platform/clusters/${id}`, body);
}
export async function archiveCluster(id: string): Promise<void> {
  await api.post(`/platform/clusters/${id}/archive`);
}
export async function restoreCluster(id: string): Promise<void> {
  await api.post(`/platform/clusters/${id}/restore`);
}
